module.exports = __webpack_public_path__ + "media/images/official/contract_form_done-387e7c15eddf10635ea1796d266cf2af.png";